import { FieldContext, FieldLocator, isMultipleChoiceField } from '@app/common/configurable-wizards';
import { MultipleChoiceCheckboxesFieldComponent }
  from '@app/common/configurable-wizards/fields/MultipleChoice/Checkboxes/MultipleChoiceCheckboxesField';

export const isUserLoansFieldInfoLocator = (fieldContext: FieldContext) => (
  isMultipleChoiceField(fieldContext.field)
  && fieldContext.field.id === 'UserLoans'
);

export const UserLoansFieldInfoLocator: FieldLocator = (context) => (
  isUserLoansFieldInfoLocator(context)
    ? MultipleChoiceCheckboxesFieldComponent
    : undefined
);
